import { MerchantPaymentPlan } from '@src/data/types/MerchantPaymentPlan'
import { subtract } from 'lodash-es'
import { Vehicle } from '../data/types'

export const formatCar = (vehicle: Vehicle | undefined | null) => {
  let ret = ''
  if (vehicle) {
    if (vehicle.make) ret = ret.concat(vehicle.make)
    if (vehicle.year) ret = ret.concat(` ${vehicle.year}`)
    if (vehicle.model) ret = ret.concat(` ${vehicle.model}`)
    if (vehicle.bodyStyle) ret = ret.concat(` ${vehicle.bodyStyle}`)
    if (vehicle.additions) ret = ret.concat(` ${vehicle.additions.map((value) => ` ${value.description}`).join()}`)
    if (vehicle.includes) ret = ret.concat(` ${vehicle.includes.map((value) => ` ${value}`).join()}`)
    if (vehicle.series) ret = ret.concat(` ${vehicle.series}`)
  }
  if (!vehicle) return ''
  return ret
}

export const formatTrimPaymentPlan = (code: string | undefined) => {
  if (code) {
    return code.replace('PLAN', '').trim()
  }
}

  export const formatPaymentPlanInterest = (plan: MerchantPaymentPlan | undefined) => {
    if (plan) {
      return `${plan.loanTerm}/${plan.reducedInterestRate}%/${plan.borrowerFeeRate}%/${plan.merchantFeeRate}%`
    }
    return ''
  }

export const formatPaymentPlanForList = (plan: MerchantPaymentPlan | undefined) => {
  if (plan) {
    const trimmedPromoCode = formatTrimPaymentPlan(plan.promoCode)
    return `${trimmedPromoCode}→${formatPaymentPlanInterest(plan)}`
  }
  return ''
}

export const formatPaymentPlanForSummary = (plan: MerchantPaymentPlan | undefined) => {
  if (plan) {
    return `${plan.reducedInterestRate}%/${plan.reducedRateDurationInMonths} → ${plan.interestRate}%/${subtract(
      plan.loanTerm,
      plan.reducedRateDurationInMonths,
    )}`
  }
  return ''
}
